import './style/index.less';
import RoleCard from './RoleCard';

export default RoleCard;
